import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../styles/Navbar.css";

import { BsTwitterX } from "react-icons/bs";
import { FaLinkedinIn, FaFacebookF, FaInstagram, FaBars, FaTimes } from "react-icons/fa";

import gsc_logo from "../assets/gwc_logo.png";

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="logo" onClick={() => navigate("/")}>
        <img src={gsc_logo} alt="GreenWorks Consulting" />
      </div>

      {/* Hamburger Icon (mobile only) */}
      <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Links */}
      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li><Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>Home</Link></li>
        <li><Link to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>About Us</Link></li>
        <li><Link to="/projects" className="nav-link" onClick={() => setMenuOpen(false)}>Projects</Link></li>
        <li><Link to="/career" className="nav-link" onClick={() => setMenuOpen(false)}>Work With Us</Link></li>
        <li><Link to="/news" className="nav-link" onClick={() => setMenuOpen(false)}>News</Link></li>
        <li><Link to="/contact-us" className="nav-link" onClick={() => setMenuOpen(false)}>Contact Us</Link></li>
      </ul>

      {/* Social Icons */}
      <div className="nav-icons">
        <div onClick={() => window.open("https://x.com/home")}>
          <BsTwitterX />
        </div>
        <div onClick={() => window.open("https://www.linkedin.com/company/93344403/admin/dashboard/")}>
          <FaLinkedinIn />
        </div>
        <div onClick={() => window.open("https://www.facebook.com/profile.php?id=61555218584816")}>
          <FaFacebookF />
        </div>
        <div onClick={() => window.open("https://www.instagram.com/jsoftbd/")}>
          <FaInstagram />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
